import React, { useContext } from "react";
import { Helmet } from "react-helmet-async";
import "./HomePage.css";
import backgroundImage from "../data/sandur.jpg";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
import { LanguageContext } from "../LanguageToggler/LanguageContextProvider";

function HomePage() {
  const { language, setLanguage } = useContext(LanguageContext);

  const scrollTo = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="justify-content-center align-content-center d-flex">
      <Helmet>
        <title>
          {language === "is" ? "Gistiheimilið Bergistangi" : "Bergistangi Guesthouse"}
        </title>
        <meta
          name="description"
          content={
            language === "is"
              ? "Gistiheimilið Bergistangi — fjölskyldurekið gistiheimili í Norðurfirði á Íslandi."
              : "Bergistangi Guesthouse — a family-run lodging in Norðurfjörður, Iceland."
          }
        />
      </Helmet>

      <div className="row">
        <div className="col">
          <div className="HomePage">
            <img src={backgroundImage} alt={language === "is" ? "Bakgrunnur" : "Background"} />
            <div className="overlay" />

            {/* Desktop: site name top-left */}
            <div id="hide" className="headercontent row">
              <div className="fontfamily col-lg-4 col-md-4 col-sm-4">
                <div id="text1">
                  {language === "is" ? (
                    <p>Gistiheimilið Bergistangi</p>
                  ) : (
                    <p>Bergistangi Lodges</p>
                  )}
                </div>
              </div>
            </div>

            {/* Nav row — always visible */}
            <div className="row headercontent">
              <div className="col" id="show">
                <div className="fontfamily2">Bergistangi</div>
              </div>
              <div
                className="col justify-content-end align-content-end d-flex"
                style={{ marginRight: "15px", marginTop: "-5px" }}
              >
                <Dropdown align="end">
                  <Dropdown.Toggle
                    as="button"
                    className="nav-hamburger-btn"
                    aria-label="Menu"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="26"
                      height="26"
                      fill="white"
                      viewBox="0 0 16 16"
                    >
                      <path d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
                    </svg>
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="nav-dropdown-menu">
                    <Dropdown.Item
                      className="nav-dropdown-item"
                      onClick={() => scrollTo("siggi")}
                    >
                      {language === "is" ? "Forsíða" : "Home"}
                    </Dropdown.Item>

                    <Dropdown.Item
                      as={Link}
                      to="/gistiadstada"
                      className="nav-dropdown-item"
                    >
                      {language === "is" ? "Gistiaðstaða" : "Accommodation"}
                    </Dropdown.Item>

                    <Dropdown.Item
                      as={Link}
                      to="/upplifun"
                      className="nav-dropdown-item"
                    >
                      {language === "is" ? "Upplifun" : "Experience"}
                    </Dropdown.Item>

                    <Dropdown.Item
                      className="nav-dropdown-item"
                      onClick={() => scrollTo("contact")}
                    >
                      {language === "is" ? "Hafa samband" : "Contact"}
                    </Dropdown.Item>

                    <div className="nav-lang-row">
                      <button
                        className={`nav-lang-btn${language === "is" ? " active" : ""}`}
                        onClick={() => setLanguage("is")}
                      >
                        ÍSL
                      </button>
                      <button
                        className={`nav-lang-btn${language === "en" ? " active" : ""}`}
                        onClick={() => setLanguage("en")}
                      >
                        ENG
                      </button>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>

            {/* Hero text */}
            <div className="welcome">
              <h6 className="nord">
                NORÐURFJÖRÐUR / {language === "is" ? "ÍSLAND" : "ICELAND"}
              </h6>
              <h1 className="welcomehead">
                {language === "is" ? (
                  <>Velkomin á <em>Bergistanga</em></>
                ) : (
                  <>Welcome to <em>Bergistangi</em></>
                )}
              </h1>
            </div>

            {/* Scroll-down arrow */}
            <div
              onClick={() => scrollTo("siggi")}
              className="justify-content-center siggi align-content-center d-flex"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" height="2em" width="2em">
                <path d="M21.886 5.536A1.002 1.002 0 0021 5H3a1.002 1.002 0 00-.822 1.569l9 13a.998.998 0 001.644 0l9-13a.998.998 0 00.064-1.033zM12 17.243L4.908 7h14.184L12 17.243z" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
